import React from 'react';
import { Layout } from '@components/index';
import { Container } from '@goodfynd/layout';
import { CmsContentRenderer } from 'features/cms/components/cms-content-renderer';
import Head from 'next/head';

import { setPageTitle } from '../utils/base';

type Custom500Props = {
  useLayout?: boolean;
};

export default function Custom500({ useLayout = true }: Custom500Props) {
  if (!useLayout) {
    return <CmsContentRenderer slug="vendor-500" />;
  }

  return (
    <Layout>
      <Head>
        <title>{setPageTitle('Oops, something went wrong 😭')}</title>
        <meta content="noindex, nofollow" name="robots" />
      </Head>

      <Container
        css={{
          '&.MuiContainer-root': {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            padding: 32,
          },
        }}
      >
        <CmsContentRenderer slug="vendor-500" />
      </Container>
    </Layout>
  );
}
